import Status, { statusTypes } from './Status';
import { useTranslation } from 'react-i18next';
import { AlarmingProps } from './types';
import { TextButton, useModal } from '@shape-ds/components';
import ListCases from 'components/Cases/List/ListCases';
import { useCaseOpenedCount } from 'pages/Asset/tabs/Cases/hooks/useCaseOpenedCount';

export const CasesAlarming = ({ asset }: AlarmingProps) => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  const count = useCaseOpenedCount(asset.id);
  const HAS_ALARMS = count > 0;

  return (
    <TextButton
      className="cases-alarming"
      startIcon={<Status status={HAS_ALARMS ? statusTypes.warning : statusTypes.offline} />}
      onClick={() =>
        openModal(<ListCases asset={asset} maxHeight={300} showTitle />, {
          PaperProps: { style: { padding: 0 }, className: 'listcase-modal' },
        })
      }
      disabled={!HAS_ALARMS}
    >
      {count} {t('components:status_indicators.cases_opened')}
    </TextButton>
  );
};
